// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lUBo","toggleWrap":"styles_toggleWrap__2eP6O","content":"styles_content__T4JpJ","selectAreaCode":"styles_selectAreaCode__UiYyF"};